import { ViewNetTermsCTA } from "./ctas";
export var Net60BasicsIA = function Net60BasicsIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(_context) {
      return NET_60_TERMS(strictLocalize);
    },
    descriptionBuilder: function descriptionBuilder(_context) {
      return [NET_60_TERMS_EXPLANATION(strictLocalize)];
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(_context) {
        return ViewNetTermsCTA(strictLocalize).label;
      },
      linkBuilder: function linkBuilder(_context) {
        var _ViewNetTermsCTA$getL, _ViewNetTermsCTA;
        return (_ViewNetTermsCTA$getL = (_ViewNetTermsCTA = ViewNetTermsCTA(strictLocalize)).getLink) === null || _ViewNetTermsCTA$getL === void 0 ? void 0 : _ViewNetTermsCTA$getL.call(_ViewNetTermsCTA);
      }
    }
  };
};
var NET_60_TERMS = function NET_60_TERMS(strictLocalize) {
  return strictLocalize({
    id: "ZLwdMl",
    defaultMessage: [{
      "type": 0,
      "value": "À propos du paiement à 60 jours"
    }]
  });
};
var NET_60_TERMS_EXPLANATION = function NET_60_TERMS_EXPLANATION(strictLocalize) {
  return strictLocalize({
    id: "DX76OY",
    defaultMessage: [{
      "type": 0,
      "value": "Le paiement à 60 jours est une option de paiement proposée sur Faire qui vous permet d'acheter des articles et de les payer 60 jours plus tard. Ces conditions de paiement vous donnent la possibilité d'acheter la quantité de produits optimale pour votre magasin, tout en gérant votre trésorerie. Pour en savoir plus, cliquez sur le bouton ci-dessous ou consultez l'article du Centre d'aide. N'hésitez pas à nous contacter si vous avez besoin d'aide."
    }]
  });
};